import { z } from 'zod'

/** Tiers a path rule can raise a PR to; rules only raise, so `low` is never useful. */
export const RISK_RULE_TIERS = ['medium', 'high'] as const

export const RiskRuleSchema = z.object({
  glob: z
    .string()
    .trim()
    .min(1)
    .max(300)
    .describe('Repo-relative glob (picomatch syntax, dotfiles included).'),
  tier: z
    .enum(RISK_RULE_TIERS)
    .describe('Tier a matching PR is raised to. Rules only raise the tier.'),
  reason: z
    .string()
    .trim()
    .min(1)
    .max(200)
    .describe('Shown with the assessment.'),
})

export const MAX_RISK_PATH_RULES = 200

/**
 * A workspace's risk rules. They are stored on the server and edited in
 * workspace settings, never read from a repository, so a PR (or the agent
 * that wrote it) cannot change the rules it is judged by.
 */
export const RiskSettingsSchema = z.object({
  useDefaults: z.boolean().describe('Include the built-in path rules.'),
  pathRules: z
    .array(RiskRuleSchema)
    .max(MAX_RISK_PATH_RULES)
    .describe('Extra path rules, applied to every repository.'),
})

export type RiskSettings = z.infer<typeof RiskSettingsSchema>

/** What a workspace without saved risk settings is judged by. */
export const DEFAULT_RISK_SETTINGS: RiskSettings = {
  useDefaults: true,
  pathRules: [],
}
